import React, { useState, useEffect } from "react";
import { PencilSquareIcon, TrashIcon, EyeIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api_url } from "../config/config";
import DeletePrompt from "../Components/common/DeletePrompt";
const ProductList = ({  totalDocuments=0}) => {
  // ...existing state

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [products, setProducts] = useState([]);
  const [rowsperpage,setRowsperpage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10; // Fixed rows per page
   const [isLoading, setIsLoading] = useState(false);

  const indexoflastitem = currentPage*rowsperpage;
  const indexoffirstitem = indexoflastitem-rowsperpage;
const currentitem = products.slice(indexoffirstitem,indexoflastitem)
const totalpages = Math.ceil(products.totalDocuments/rowsperpage);

  const [showDetails, setShowDetails] = useState(false); // Add this line
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm); // Debounced value
  const navigate = useNavigate();
  const token = localStorage.getItem("admin_token");
  const [selectedVariant, setSelectedVariant] = useState(null);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = products.slice(indexOfFirstItem, indexOfLastItem);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };


  useEffect(() => {
    const handler = setTimeout(() => {
      setCurrentPage(1);
      setDebouncedSearchTerm(searchTerm);
    }, 500);
  
    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  const handleVariantSelect = (variant) => {
    setSelectedVariant(variant); // Set selected variant
  };


  const fetchProductList = async (e) => {
    const keyword = e.target.value;
    setIsLoading(true);
    setSearchTerm(keyword);
  
    try {
      const { data } = await axios.get(
        `${api_url}/products-search?query=${keyword}&page=${currentPage}&limit=${itemsPerPage}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
          },
        }
      );
  
      console.log("product", data.data);
      setProducts(data.data);
    } catch (e) {
      console.log(e);
    }
  
    setIsLoading(false);
  };
  
  
 
  
  
  // const handleDeleteProduct = async (productId) => {
  //   try {
  //     await axios.delete(`${api_url}/product/${productId}`, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
  //       },
  //     });
  //     toast.success("Product deleted successfully");
  //     setProducts((prevProducts) => prevProducts.filter(prod => prod.product_id !== productId));
  //     setShowDeleteModal(false);
  //     setProductToDelete(null);
  //   } catch (e) {
  //     toast.error(e.response?.data?.error?.message || "Failed to delete product");
  //     setShowDeleteModal(false);
  //     setProductToDelete(null);
  //   }
  // };

  const handleAddProduct = () => {
    navigate("/ng-admin/add-product", { replace: true });
};

  

  // const handleAddProduct = () => {
  //   window.location.href = "/ng-admin/add-product"; // Hard reload
  // };
  

  const handleEdit = (productCode) => {
    navigate(`/ng-admin/edit-product/${productCode}`);
  };
  

  const handleViewDetails = async (prod) => {
    try {
      const { data } = await axios.get(
        `${api_url}/admin-product/${prod?.product_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Fetched Product Details:", data); // Debugging line
      setSelectedProduct(data.data);
      console.log("selected",data.data)
      
      // Update selected product
      setShowDetails(true); // Show the details container
    } catch (error) {
      console.error("Error fetching product details:", error);
      toast.error("Failed to fetch product details. Please try again.");
    }
  };
  

  const closeDetails = () => {
    setShowDetails(false);
    setSelectedProduct(null);
  };

  const fetchProducts = async () => {
    try {
      setLoading(true);

      const url = debouncedSearchTerm
        ? `${api_url}/admin-products?query=${debouncedSearchTerm}&page=${currentPage}&limit=${itemsPerPage}`
        : `${api_url}/admin-products?page=${currentPage}&limit=${itemsPerPage}`;
  
      const response = await axios.get(url, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
      });
  
      console.log("products fetched:", response.data);
  
      setProducts(response.data.results || response.data.data || []);
      setTotalPages(Math.ceil(response.data.totalDocuments / itemsPerPage));
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error("Failed to fetch products. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchProducts();
  }, [currentPage, debouncedSearchTerm]);
  

  const handleCheckboxChange = async (productId, isChecked) => {
    console.log("checked",isChecked)
    try {
      // Sync with backend
      await axios.patch(
        `${api_url}/featured/product`,
        { product_id: productId, selected: isChecked },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      // Update the local state to reflect the change
      setProducts((prevProducts) =>
        // console.log("prod",prevProducts),

        prevProducts.map((prod) =>
          prod.product_id === productId ? { ...prod, featuredProduct: isChecked } : prod
        )
      );

    } catch (error) {
      console.error("Error updating product:", error);
      alert("Failed to update product. Please try again.");
    }
    
  };
  const handleCheckboxChangeForCartProduct = async (productId, isChecked) => {
    console.log("checked",isChecked)
    try {
      // Sync with backend
      await axios.patch(
        `${api_url}/cart-list-products/${productId}`,
        { isCartProduct: isChecked },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      // Update the local state to reflect the change
      setProducts((prevProducts) =>
        // console.log("prod",prevProducts),

        prevProducts.map((prod) =>
          prod.product_id === productId ? { ...prod, isCartProduct: isChecked } : prod
        )
      );

    } catch (error) {
      console.error("Error updating product:", error);
      alert("Failed to update product. Please try again.");
    }
    
  };

  
 
  const handleSoftDeleteCheckboxChange = async (productId, isChecked) => {
    try {
      const status = isChecked ? 'Yes' : 'No';
      await axios.patch(
        `${api_url}/delete-product/${productId}`,
        { isDeleted: status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
     
      setProducts(prevProducts =>
        prevProducts.map(prod =>
          prod.product_id === productId ? { ...prod, isDeleted: status } : prod
        )
      );
   
    } catch (error) {
      console.error('Error soft deleting product:', error);
      alert('Failed to update product status.');
    } 
  };

  // useEffect(() => {
  //   fetchProducts(currentPage);
  // }, [currentPage]);

  
  

  


 
  return (
    <div className="flex flex-col">
          <ToastContainer />
            
       <div className="flex-grow overflow-auto rounded-lg relative bg-white shadow-lg">
      <h2 className="text-2xl font-bold mb-4 mt-7 px-5">Product List</h2>
      <div className="p-6 h-[700px] overflow-y-scroll mb-10">
      <div className="flex justify-between items-center w-full mb-4 gap-4">
          <div className="w-full flex gap-5">
          <input
  type="text"
  className="border rounded-xl border-slate-700 p-2 w-[300px] px-3"
  placeholder="Product Name"
  value={searchTerm}
  onChange={e=> setSearchTerm(e.target.value)}
/>

</div>
            <div className="flex justify-end items-center w-full mb-4 gap-4">
              <button
                className="bg-[#3C1F1F]  text-[13px] w-30 h-8 text-white py-1 rounded-lg hover:bg-blue-600 transition px-4"
                onClick={() => navigate('/ng-admin/Bulk-Product')}
              >
                Bulk Upload Product
              </button>
           
              <button
                className="bg-[#3C1F1F]  text-[13px] w-30 h-8 text-white px-2 py-1 rounded-lg hover:bg-blue-600 transition"
                onClick={handleAddProduct}
              >
                Add Product
              </button>
            </div>
          </div>
        <table className="table-auto w-full text-sm text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-6 py-3">Product Name</th>

              <th className="px-6 py-3 min-w-[150px]">Product Code</th>
              <th className="px-6 py-3">Price</th>
              <th className="px-6 py-3 min-w-[150px]">Discounted Price</th>
              <th className="px-6 py-3">Actions</th>
              <th className="px-6 py-3">In Active</th>
              <th className="px-6 py-3">Featured</th>
              <th className="px-6 py-3">Trending Products</th>
            
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="6" className="text-center py-4">Loading...</td></tr>
            ) : products.length > 0 ? (
              products.map((prod) => (
                <tr key={prod?.product_code} className="hover:bg-gray-100">
                  <td className="px-6 py-3 flex items-center">
                  <img
                      src={prod?.product_images?.image_url?.primary_image || "https://via.placeholder.com/50"}
                      alt={prod?.name || "Product Image"}
                      className="h-8 w-8 object-cover rounded mr-2"
                    />
                    {prod?.name}
                  </td>
                  <td className="px-6 py-3">{prod?.product_code}</td>
                  <td className="px-6 py-3 font-inter">₹{prod?.variant?.[0]?.price|| "N/A"}</td>
                  <td className="px-6 py-3 font-inter">₹{prod?.variant?.[0]?.discounted_price|| "N/A"}</td>
                  <td className="px-6 py-3 flex space-x-2">
                    <EyeIcon className="h-5 w-5 text-[#3C1F1F] cursor-pointer hover:text-blue-700" onClick={() => handleViewDetails(prod)} />
                    <PencilSquareIcon className="h-5 w-5 text-[#3C1F1F] cursor-pointer hover:text-blue-700" onClick={() => handleEdit(prod?.product_id)} />
              
                  </td>
                  <td className="px-6 py-3">
  <div className="form-checkbox-wrapper">
    <input
      type="checkbox"
      className="cursor-pointer"
      checked={prod.isDeleted === 'Yes'}
      onChange={e => handleSoftDeleteCheckboxChange(prod.product_id, prod.isDeleted !== 'Yes')}

    />
 
  </div>
</td>
                  <td className="px-6 py-3">
                    <div className="form-checkbox-wrapper">
                      <input
                        type="checkbox"
                        className="cursor-pointer"
                        checked={prod.featuredProduct}
                        onChange={() => handleCheckboxChange(prod.product_id, !prod.featuredProduct)}
                      />
                    </div>
                  </td>
                  <td className="px-6 py-3">
                    <div className="form-checkbox-wrapper">
                      <input
                        type="checkbox"
                        className="cursor-pointer"
                        checked={prod.isCartProduct}
                        onChange={() => handleCheckboxChangeForCartProduct(prod.product_id, !prod.isCartProduct)}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="6" className="text-center py-4">No Products Found</td></tr>
            )}
          </tbody>
        </table>

        {/* Pagination Controls */}
        {totalPages > 1 && itemsPerPage >= 10 && (
  <div className="flex justify-center mt-6 space-x-2">
    <button
      onClick={() => handlePageChange(currentPage - 1)}
      disabled={currentPage === 1}
      className={`px-4 py-2 rounded ${
        currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-[#3C1F1F] text-white hover:bg-blue-600"
      }`}
    >
      Prev
    </button>
    <span className="px-4 py-2 bg-gray-200 text-gray-900 rounded font-semibold">{currentPage}</span>
    <button
      onClick={() => handlePageChange(currentPage + 1)}
      disabled={currentPage >= totalPages}
  className={`px-4 py-2 rounded ${
   (currentPage >= totalPages)
      ? "bg-gray-300 cursor-not-allowed"
      : "bg-[#3C1F1F] text-white hover:bg-blue-600"
  }`}
    >
      Next
    </button>
  </div>
)}


      </div>
    </div>


   
      {showDetails && selectedProduct && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end z-50 font-[Poppins]">
    <div className="relative bg-white shadow-lg rounded-l-lg w-1/3 h-full max-h-screen overflow-y-auto animate-slide-in-right">

      {/* Sticky Header with Close Button */}
      <div className="sticky top-0 bg-white z-10 border-b px-6 py-4 flex justify-between items-center">
        <h2 className="text-xl font-extrabold text-gray-700">Product Details</h2>
        <button
          onClick={closeDetails}
          className="absolute top-4 right-4 bg-red-500 text-white p-2 rounded-full shadow hover:bg-red-600 focus:outline-none"
        >
          ✕
        </button>
      </div>

 
      <div className="p-6 grid grid-cols-1 gap-y-6 text-sm">
        <div><strong>Name:</strong> {selectedProduct?.name || "N/A"}</div>
        <div><strong>Code:</strong> {selectedProduct?.product_code || "N/A"}</div>
        <div><strong>Description:</strong> {selectedProduct?.description || "N/A"}</div>
        <div><strong>Category:</strong> {selectedProduct?.category_ids?.map(c => c.category_name).join(", ") || "N/A"}</div>
        <div><strong>Concern:</strong> {selectedProduct?.concern_ids?.map(c => c.concern_name).join(", ") || "N/A"}</div>
        <div><strong>Manufacturer:</strong> {selectedProduct?.manufacturer?.name || "N/A"}</div>
        <div><strong>Composition:</strong> {selectedProduct?.composition || "N/A"}</div>
        <div><strong>Pack Type:</strong> {selectedProduct?.pack_type || "N/A"}</div>
        <div><strong>Consume Type:</strong> {selectedProduct?.consume_type || "N/A"}</div>
        <div><strong>Expire Date:</strong> {selectedProduct?.expire_date || "N/A"}</div>
        <div><strong>Benefits:</strong> {selectedProduct?.benefits || "N/A"}</div>
        <div><strong>How to Use:</strong> {selectedProduct?.how_to_use || "N/A"}</div>
        <div><strong>Safety Advice:</strong> {selectedProduct?.safety_advise || "N/A"}</div>
        <div><strong>Prescription Required:</strong> {selectedProduct?.prescription_required || "N/A"}</div>
        <div><strong>Primary Use:</strong> {selectedProduct?.primary_use || "N/A"}</div>
        <div><strong>Storage Instruction:</strong> {selectedProduct?.storage_instruction || "N/A"}</div>
        <div><strong>Side Effects:</strong> {selectedProduct?.side_effects || "N/A"}</div>
        <div><strong>Return Policy:</strong> {selectedProduct?.return_policy || "N/A"}</div>
        <div><strong>Alternatives:</strong> {Array.isArray(selectedProduct?.alternativeProducts) && selectedProduct.alternativeProducts.length > 0
          ? selectedProduct.alternativeProducts.map((alt) => alt.name).join(", ")
          : "N/A"}
        </div>
        <div><strong>Key Ingredients:</strong> {selectedProduct?.key_ingredients || "N/A"}</div>
        <div><strong>Shelf Rack No:</strong> {selectedProduct?.shelf_rack_no || "N/A"}</div>

        

        {/* Images */}
        <div className="mt-4">
          <strong className="block mb-2">Primary Image:</strong>
          {selectedProduct?.product_images?.image_url?.primary_image ? (
            <img
              src={selectedProduct.product_images.image_url.primary_image}
              alt="Primary"
              className="w-[200px] h-[200px] object-cover rounded border"
            />
          ) : (
            <p className="italic text-gray-500">No primary image available</p>
          )}
        </div>

        {selectedProduct?.product_images?.image_url?.additional_images?.length > 0 && (
          <div className="mt-4">
            <strong className="block mb-2">Additional Images:</strong>
            <div className="flex flex-wrap gap-3">
              {selectedProduct.product_images.image_url.additional_images.map((url, idx) => (
                <img
                  key={idx}
                  src={url}
                  alt={`Additional ${idx}`}
                  className="w-20 h-20 object-cover rounded border"
                />
              ))}
            </div>
          </div>
        )}

        {/* Variants Section */}
        <div className="mt-6">
          <h3 className="text-md font-semibold text-gray-700 mb-2">Variants:</h3>
          {selectedProduct?.variant?.length > 0 ? (
            selectedProduct.variant.map((variant, idx) => (
              <div key={idx} className="border p-4 mb-4 rounded bg-gray-50">
                <p><strong>Price:</strong> ₹{variant.price || "N/A"}</p>
                <p><strong>Discounted Price:</strong> ₹{variant.discounted_price || "N/A"}</p>
                <p><strong>Quantity:</strong> {variant.quantity || "N/A"}</p>
                <p><strong>Pack Size:</strong> {variant.pack_size || "N/A"}</p>
                <p><strong>Product Size:</strong> {variant.product_size || "N/A"}</p>
              </div>
            ))
          ) : (
            <p className="italic text-gray-500">No variants available</p>
          )}
        </div>
      </div>
    </div>
  </div>
)}




      
      <ToastContainer />
      {/* Delete Confirmation Modal */}
      {/* <DeletePrompt
        showModal={showDeleteModal}
        onDelete={() => productToDelete && handleDeleteProduct(productToDelete)}
        onCancel={() => {
          setShowDeleteModal(false);
          setProductToDelete(null);
        }}
      /> */}
    </div>
  );
};



export default ProductList;
